import Header from "./Header";
import Footer from "./Footer";
function LayoutsHome({children}){
    return(
        <>
        <Header />
        <div>{children}</div>
        {/* <h2>I am Layouts section</h2> */}
        <Footer />
        </>
    )
}
export default LayoutsHome;